import { useEffect, useState } from "react"
import supabaseData from "../supabase"
// import { useDispatch } from "react-redux"

export default function useFiresideChats() {
  const [firesideChats, setFiresideChats] = useState([])
//   const dispatch = useDispatch()
  
  useEffect(() => {
    let isMounted = true

    supabaseData.firesideChats
      .getAllCompleted()
      .then(res => {
        if (isMounted) {
          setFiresideChats(res)
        }
      })
      .catch(error => {
        console.error("Failed to load Fireside Chats from Supabase", error)
      })

    return () => {
      isMounted = false
    }
  }, [])

  return { firesideChats }
}
